module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Install app","installing":"App installed"},"de":{"text":"App installieren","installing":"App installiert"}}')
  delete Component.options._Ctor
}
